<template>
  <el-container
    class="container-list is-vertical page-user-detail"
    style="height: 100%; width: 100%; position: fixed;"
  >
    <top-header>
      <template slot="left">
        <div style="width: max-content; height:100%; display: inline-flex; align-items: center; justify-content: center;top: 0;position: absolute;">
          <el-breadcrumb separator-class="el-icon-arrow-right" class="white">
            <el-breadcrumb-item :to="{ path: '/user', query:{page:$route.query.frompage || 1, keyword: $route.query.keyword, sorting: $route.query.sorting} }">顧客管理 P{{$route.query.frompage || 1}}</el-breadcrumb-item>
            <el-breadcrumb-item>{{title}}</el-breadcrumb-item>
          </el-breadcrumb>
        </div>
      </template>
      <template slot="right">
      </template>
    </top-header>
    <el-container>
      <left-menu />

      <el-main v-loading="isLoading">

        <el-container style="height: 100%;">

          <el-aside width="30%" style="background-color: rgb(238, 241, 246); padding: 8px;">
            <!-- 顧客資訊 -->
            <h3 style="text-align: left">顧客資訊</h3>
            <hr>

            <div class="info-wrapper">
              <p class="info-title">姓名</p>
              <p class="info-content">{{user.Profile.Name}}</p>

              <p class="info-title">電話</p>
              <p class="info-content">{{user.Profile.Phone}}</p>

              <p class="info-title">電郵</p>
              <p class="info-content">{{user.Profile.Email}}</p>

              <p class="info-title">生日</p>
              <p class="info-content">{{user.Profile.BirthYear}}/{{user.Profile.BirthMonth}}/{{user.Profile.BirthDay}}</p>

              <p class="info-title">加入日期</p>
              <p class="info-content">{{user.Profile.CreatedAt | dateFormat}}</p>

              <p class="info-title">最後登入日期</p>
              <p class="info-content">{{user.Detail.LastLoginedAt | dateFormat}}</p>
            </div>
          </el-aside>

          <el-main>
            <!-- 訂單 -->
            <h3 style="text-align: left">訂單
              <el-date-picker
                size="mini"
                v-model="orderFilteringDateRange"
                type="daterange"
                unlink-panels
                range-separator="至"
                start-placeholder="開始日期"
                end-placeholder="結束日期"
                @input="onOrderDateRangeChanged">
              </el-date-picker>
              <!-- <el-date-picker
                size="small"
                @change="onOrderMonthChanged"
                width="100px"
                v-model="orderFilteringMonth"
                type="month"
                placeholder="選擇月份"
                :clearable="true">
              </el-date-picker> -->
              <small>累積 NT${{orderAmountSum | amountFormat}}</small>
              <el-button size="small" style="float:right;" @click="exportOrders">匯出</el-button>
            </h3>
            <hr>
            <el-table :data="filteredOrders" stripe height="calc(50% - 50px)">
              <template slot="empty">
                沒有資料
              </template>
              <el-table-column label="訂單號碼">
                <template slot-scope="scope">
                  <a class="order-id" href="javascript:;" @click="$router.push({ name: 'order-detail', params: { id: scope.row.ID }})">
                    {{scope.row | getOrderID}}</a>
                </template>
              </el-table-column>
              <el-table-column label="訂單日期">
                <template slot-scope="scope">
                  {{scope.row.CreatedAt | dateFormat}}
                </template>
              </el-table-column>
              <el-table-column label="訂單狀態">
                <template slot-scope="scope">
                  <span :class="`order-status ${scope.row.OrderStatus}`">{{scope.row.OrderStatus}}</span>
                </template>
              </el-table-column>
              <el-table-column label="付款狀態">
                <template slot-scope="scope">
                  <span :class="`payment-status ${scope.row.PaymentStatus}`">{{scope.row.PaymentStatus}}</span>
                </template>
              </el-table-column>
              <el-table-column label="送貨狀態">
                <template slot-scope="scope">
                  <span :class="`logistics-status ${scope.row.LogisticsStatus}`">{{scope.row.LogisticsStatus}}</span>
                </template>
              </el-table-column>
              <!-- <el-table-column label="訂購人">
                <template slot-scope="scope">
                  {{scope.row.User && scope.row.User.Username}}
                </template>
              </el-table-column> -->
              <el-table-column label="合計">
                <template slot-scope="scope">
                  NT${{scope.row.Amount|amountFormat}}
                </template>
              </el-table-column>
            </el-table>
            <!-- 購物金 -->
            <h3 style="text-align: left; margin-top: 20px;">購物金 <small>現有 NT${{user.Detail.VoucherAmount | amountFormat}}
              <a href="javascript:;" @click="isShowEditAddVoucherModal = true" class="btn-edit">新增</a>
              </small>
            </h3>
            <hr>
            <!-- <span style="text-align: left" class="left">現有購物金: {{user.Detail.VoucherAmount}}</span> -->
            <el-table :data="vouchers" stripe height="calc(50% - 50px)">
              <template slot="empty">
                沒有資料
              </template>
              <el-table-column label="日期" width="110">
                <template slot-scope="scope">
                  {{scope.row.CreatedAt | dateFormat}}
                </template>
              </el-table-column>
              <el-table-column label="明細">
                <template slot-scope="scope">
                  {{scope.row.Type}}
                </template>
              </el-table-column>
              <el-table-column label="金額" width="60">
                <template slot-scope="scope">
                  {{scope.row.Amount}}
                </template>
              </el-table-column>
              <el-table-column label="到期日" width="110">
                <template slot-scope="scope">
                  {{scope.row.Deadline | dateFormat}}
                </template>
              </el-table-column>
              <el-table-column label="剩餘" width="60">
                <template slot-scope="scope">
                  {{scope.row.Left}}
                </template>
              </el-table-column>
              <el-table-column label="可用" width="60">
                <template slot-scope="scope">
                  {{scope.row.AvailableBalance}}
                </template>
              </el-table-column>
              <el-table-column label="管理員備註">
                <template slot-scope="scope">
                  {{scope.row.AdminRemark}}
                </template>
              </el-table-column>
            </el-table>

          </el-main>

        </el-container>

        <voucher-add-modal :is-show="isShowEditAddVoucherModal" @close="isShowEditAddVoucherModal=false" @submitted="onVoucherAdded" :user-i-d="userID"/>

      </el-main>
    </el-container>
  </el-container>
</template>

<script>
import moment from 'moment'
import LeftMenu from '@/views/components/LeftMenu.vue'
import TopHeader from '@/views/components/TopHeader.vue'
import VoucherAddModal from './model-addedit-voucher'
// excel
import ExcelGenerator from '../../order/excel'
import XLSXSaver from '@/utils/excel/xlsx-saver.js'
// svgs
import '@/assets/svgs/index.js'
// mixin
import MixinFilters from '@/utils/filters/filter-mixin.vue'
import MixinDelaySearch from '@/utils/mixin-delaysearch.vue' // filterObjs method required
export default {
  mixins: [MixinFilters, MixinDelaySearch],
  components: {
    LeftMenu,
    TopHeader,
    VoucherAddModal
  },
  data () {
    return {
      vouchers: [],
      isShowEditAddVoucherModal: false,
      // 訂單
      orderFilteringDateRange: null,
      orderFilteringMonth: null,
      allOrders: [],
      filteredOrders: []
    }
  },
  computed: {
    userID () {
      return this.$route.params.id
    },
    user () {
      return this.$store.state.user.list.find(o => o.ID === this.userID) || {}
    },
    title () {
      return (this.user.Profile || {}).Name
    },
    orderAmountSum () {
      if (this.orderFilteringDateRange && this.orderFilteringDateRange.length) {
        return this.filteredOrders.filter(o => o.PaymentStatus == '已付款').reduce((sum, o) => sum + o.Amount, 0)
      }
      if (this.orderFilteringMonth) {
        return this.filteredOrders.filter(o => o.PaymentStatus == '已付款').reduce((sum, o) => sum + o.Amount, 0)
      }
      return this.user.Detail.OrderAmountSum
    }
  },
  methods: {
    onVoucherAdded (data) {
      this.vouchers.splice(0, 0, data)
    },
    onOrderMonthChanged () {
      let yearMonthString = null
      if (this.orderFilteringMonth) yearMonthString = moment(this.orderFilteringMonth).format('yyyy-MM')
      this.filteredOrders = this.allOrders.filter(o => {
        if (!yearMonthString) return true
        return moment(o.CreatedAt).format('yyyy-MM') == yearMonthString
      })
    },
    onOrderDateRangeChanged () {
      let startDate = this.orderFilteringDateRange && moment(this.orderFilteringDateRange[0])
      let endDate = this.orderFilteringDateRange && moment(this.orderFilteringDateRange[1])
      this.filteredOrders = this.allOrders.filter(o => {
        if (!this.orderFilteringDateRange) return true
        let date = moment(o.CreatedAt)
        let result = (date.isBefore(endDate) && date.isAfter(startDate)) || date.isSame(startDate, 'date') || date.isSame(endDate, 'date')
        return result
      })
    }, // copy from order/list.vue
    exportOrders () {
      const exportExcel = () => {
        try {
          let datas = this.filteredOrders
          let result = ExcelGenerator.generate(this, datas)

          var fileName = window.prompt(
            '請輸入匯出Excel檔之名稱',
            '旬果屋購物官網-訂單匯出'
          )
          if (fileName === null) return // 取消
          if (!fileName) return window.alert('請輸入檔案名稱')
          XLSXSaver.saveAs(result, fileName)
        } catch (e) {
          alert('發生錯誤:' + e)
          window.console.error(`匯出異常`, e)
        }
      }

      // 1. load with details
      var ids = this.searchedObjs.map(o => o.ID)

      this.$services.order.getOrderListWithDetail(this, ids).then(res => {
        var orders = res.data.result
        for (let order of orders) {
          let idx = this.$store.state.order.list.findIndex(o => o.ID === order.ID)
          if (idx >= 0) this.$set(this.$store.state.order.list, idx, order)
          // filter again
          this.filterObjs()
        }
        // 2. export
        exportExcel()
      }).catch(this.$handleServiceError)
    }
  },
  created () {
    // query...
    let promise1 = this.$services.user.getUserOrders(this, this.userID).then(res => {
      this.allOrders = res.data.result
      this.filteredOrders = this.allOrders
    })
    let promise2 = this.$services.user.getUserVouchers(this, this.userID).then(res => {
      this.vouchers = res.data.result
    })

    Promise.all([promise1, promise2]).then(res => {

    }).catch(this.$handleServiceError)
  }
}
</script>

<style>
.page-user-detail h3 small {
    font-size: 13px;
    color: #666;
    font-weight: bold;
}

.info-wrapper {
  padding: 15px;
}

.info-title {
  font-size: 13px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.46;
  letter-spacing: normal;
  text-align: left;
  color: rgb(112, 112, 112);

  margin-bottom: 10px;
}

.info-content {
  font-size: 13px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.46;
  letter-spacing: normal;
  text-align: left;
  color: rgb(112, 112, 112);

  margin-bottom: 30px;
}
</style>
